export default function ErrorMsgDialog(data) {
    //language=HTML
    return `
        <section class="${data.templateKlass} position-absolute">
            <div class="animate__animated animate__zoomIn">
                <div class="row justify-content-between align-items-center bg-danger ${data.textKlass} m-0 px-2 py-1">
                    <span class="fa-1-5x">${data.errorsCount} ${data.translateId("error")}</span>
                    <div class=" d-flex justify-content-between align-items-center">
                        <a role="button" id="exportToExcel" title='${data.translateId("exportcsv")}' class=" pr-2 ${data.textKlass}"><i
                                class="fa-solid fa-file-excel fa-1-5x"></i></a>
                        <a role="button" id="createTroubleTicket" title='${data.translateId("createTroubleTicket")}'
                           class=" pr-2 ${data.textKlass}"><i
                                class="fa-solid fa-circle-plus fa-1-5x"></i></a>
                        <a role="button" class=" pr-2 btn-close-errors ${data.textKlass}"><i class="fa-solid fa-xmark fa-1-5x"></i></a>
                    </div>
                </div>
                <div class="container py-1">

                </div>
            </div>
        </section>`;
}